import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/services/authentication.service';
import { Observable } from 'rxjs';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  public constructor(private readonly authenticationService: AuthenticationService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken: string = this.authenticationService.getToken();

    if (!accessToken) {
      return next.handle(request);
    }

    const headers: HttpHeaders = request.headers
      .set('Access-Control-Allow-Credentials', 'true')
      .set('Authorization', `Bearer ${accessToken}`);

    const requestWithCredentials: HttpRequest<unknown> = request.clone({ headers });

    return next.handle(requestWithCredentials);
  }
}
